import { formatDBDate } from '@/utils/date';

/**
 * sales-reports-fe-api.md §3: startDate/endDate phải truyền cặp hoặc bỏ cả hai.
 */
export const resolveSalesReportDateRange = (filters = {}) => {
  const startDate = formatDBDate(filters.startDate);
  const endDate = formatDBDate(filters.endDate);
  const hasStart = Boolean(startDate);
  const hasEnd = Boolean(endDate);

  if (hasStart !== hasEnd) {
    return {
      valid: false,
      message: 'Vui lòng chọn cả Từ ngày và Đến ngày, hoặc bỏ trống cả hai để xem toàn thời gian.',
      startDate: null,
      endDate: null,
      hasDateRange: false,
    };
  }

  return {
    valid: true,
    message: null,
    startDate,
    endDate,
    hasDateRange: hasStart && hasEnd,
  };
};

export const formatSalesReportPeriodLabel = (filters = {}) => {
  const { hasDateRange, startDate, endDate } = resolveSalesReportDateRange(filters);
  if (!hasDateRange) {
    return 'Toàn thời gian';
  }
  return `Kỳ ${startDate} → ${endDate}`;
};
